// src/utils/waSource.js
//
// Guarda de dónde vino el visitante (ej: ?ref=ig desde el link de la bio de
// Instagram) y lo agrega automáticamente a los mensajes de WhatsApp, para
// saber qué canal genera cada consulta sin instalar nada externo.

const STORAGE_KEY = "ls_lead_source";

const LABELS = {
  ig: "Instagram",
  instagram: "Instagram",
  wa: "WhatsApp",
  whatsapp: "WhatsApp",
  fb: "Facebook",
  facebook: "Facebook",
  tiktok: "TikTok",
  google: "Google",
};

/**
 * Se llama una vez al cargar la app. Si la URL trae ?ref=ig o
 * ?utm_source=instagram, lo guarda para toda la sesión del visitante.
 */
export function captureLeadSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref") || params.get("utm_source");
    if (raw) {
      const label = LABELS[raw.toLowerCase()] || raw;
      sessionStorage.setItem(STORAGE_KEY, label);
    }
  } catch (e) {
    // sessionStorage puede fallar en navegación privada estricta;
    // si eso pasa, simplemente no taggeamos el origen.
  }
}

/**
 * Devuelve una línea lista para sumar al mensaje de WhatsApp
 * (o null si no se detectó ningún origen en esta sesión).
 */
export function getLeadSourceLine() {
  try {
    const source = sessionStorage.getItem(STORAGE_KEY);
    return source ? `• Origen: ${source}` : null;
  } catch (e) {
    return null;
  }
}
